import { render, staticRenderFns } from "./H5BannerLong.vue?vue&type=template&id=598363d5&scoped=true"
import script from "./H5BannerLong.vue?vue&type=script&lang=js"
export * from "./H5BannerLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598363d5",
  null
  
)

export default component.exports